import * as React from "react";
import { Accordion, AccordionItem, RichTextArea } from "@grandvisionhq/common";
import { compose } from "@grandvisionhq/utils";
import { withBreakpointVisibility } from "../../../../hocs/hocs/with-breakpoint-visibility.js";
import { withHidableContent } from "../../../../hocs/hocs/with-hidable-content.js";
import { withBloomreachPageable } from "../../../../hocs/hocs/with-bloomreach-pageable.js";
import { withAnchor } from "../../../../hocs/hocs/with-anchor.js";
import { withEditableContent } from "../../../../hocs/hocs/with-editable-content.js";
import { useBloomreachRichText } from "../../../../hooks/hooks/use-bloomreach-rich-text.js";
const CmsAccordionItem = withEditableContent(
  ({ content, expanded, headingLevel }) => {
    const richText = useBloomreachRichText(content.content?.value);
    return /* @__PURE__ */ React.createElement(
      AccordionItem,
      {
        id: content.id,
        label: content.title,
        expanded,
        headingLevel,
        fullWidth: true
      },
      /* @__PURE__ */ React.createElement(RichTextArea, { content: richText })
    );
  }
);
const CmsAccordion = ({ headingLevel, meta, content }) => /* @__PURE__ */ React.createElement(Accordion, null, content.items.map((item, i) => /* @__PURE__ */ React.createElement(
  CmsAccordionItem,
  {
    key: item.id,
    content: item,
    headingLevel,
    expanded: meta.expandedByDefault === `${i + 1}`
  }
)));
const CmsAccordion$1 = compose(
  withBreakpointVisibility,
  withHidableContent,
  withBloomreachPageable,
  withAnchor
)(CmsAccordion);
export {
  CmsAccordion,
  CmsAccordionItem,
  CmsAccordion$1 as default
};
//# sourceMappingURL=Accordion.js.map
